"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateItemDelta = CreateItemDelta;
function CreateItemDelta(partial) {
    return {
        changed: partial.changed || [],
        inserted: partial.inserted || [],
        discarded: partial.discarded || [],
        ignored: partial.ignored || [],
        unerrored: partial.unerrored || [],
    };
}
